<template>
  <div class="addParamsInput" style="width:97.8%;border:1px solid #e0e0e0;margin-left:14px;">
    <div class="titleForm-container">增加参数录入</div>
    <div class="content-form-container">
      <div class="main-container-form">
        <el-form :model="baseForm" :rules="rules" ref="baseForm" label-width="100px" class="ruleForm">
          <el-form-item label="所在基地" prop="fishBaseId">
            <el-select v-model="baseForm.fishBaseId" placeholder="请选择基地" size="medium" style="width:100%;" @change="baseChange">
              <el-option
                  v-for="(item, index) in baseList"
                  :key="index"
                  :label="item.value"
                  :value="item.key">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在塘口" prop="pondId">
            <el-select v-model="baseForm.pondId" placeholder="请选择塘口" size="medium" style="width:100%;" >
              <el-option
               v-for="item in pondList"
                :key="item.id" 
                :label="item.value" 
                :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-row >
            <el-form-item label="录入日期" prop="dataTime">
              <el-col :span="24">
                <el-date-picker
                  prefix-icon="el-icon-date"
                  v-model="baseForm.dataTime"
                  type="datetime"
                  style="width: 100%;"
                  value-format="yyyy-MM-dd HH:mm:ss" 
                  placeholder="请选择日期时间">
                </el-date-picker>
              </el-col>
            </el-form-item>
          </el-row>
          <el-form-item label="溶解氧" prop="do">
            <el-input 
            v-model.number="baseForm.do"  
            :maxlength="num11" 
            placeholder="请输入溶解氧"
             onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" 
             size="medium" 
             style="width:100%;">
             <i slot="suffix" style="font-style:normal">mg/L</i>
             </el-input>
          </el-form-item>
          <el-form-item label="PH" prop="ph">
            <el-input 
            v-model.number="baseForm.ph"  
            :maxlength="num11" 
            placeholder="请输入PH"
             onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" 
             size="medium" 
             style="width:100%;">
             </el-input>
          </el-form-item>
          <el-form-item label="水温" prop="temp">
            <el-input 
            v-model.number="baseForm.temp"  
            :maxlength="num11" 
            placeholder="请输入水温" 
            onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" 
            size="medium" 
            style="width:100%;">
            <i slot="suffix" style="font-style:normal">℃</i>
            </el-input>
          </el-form-item>
          <el-form-item label="氧化电还原" prop="electroRedox">
            <el-input 
            v-model.number="baseForm.electroRedox"  
            :maxlength="num11" 
            placeholder="请输入氧化电还原" 
            onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" 
            size="medium" style="width:100%;">
            <i slot="suffix" style="font-style:normal">mV</i>
            </el-input>
          </el-form-item>
          <el-form-item label="亚盐" prop="nitrite">
            <el-input
              v-model.number="baseForm.nitrite"
              :maxlength="num11"
              placeholder="请输入亚盐"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              size="medium"
              style="width:100%;"
            >
              <i slot="suffix" style="font-style:normal">mg/L</i>
            </el-input>
          </el-form-item>
          <el-form-item label="氨氮" prop="ammoniaNitrogen">
            <el-input
              v-model.number="baseForm.ammoniaNitrogen"
              :maxlength="num11"
              placeholder="请输入氨氮"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              size="medium"
              style="width:100%;"
            >
              <i slot="suffix" style="font-style:normal">mg/L</i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-col :span="8">
              <el-button class="save-btn" @click="saveBase('baseForm')">保存</el-button>
            </el-col>
            <el-col :span="8">
              <el-button class="cancel-btn" @click="cancelForm('ruleForm')">取消</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { modules } from "../../../../store";
import { MessageBox, Message } from "element-ui";
export default {
  name: "addParamsInput",
  data() {
    return {
      num20: 20,
      num11: 11,
      num30: 30,
      pondList: [], //塘口列表
      baseList: [], //基地列表
      baseForm: {
        fishBaseId: "", //基地
        electroRedox: "", //氧化电还原
        temp: "", //水温
        do: "", //溶解氧
        ph: "", //ph
        nitrite: "",
        ammoniaNitrogen: "",
        dataTime: "",
        pondId: "" // 所在塘口
      },
      rules: {
        fishBaseId: [
          { required: true, message: "请先选择基地", trigger: "blur" }
        ],
        pondId: [{ required: true, message: "请先选择塘口", trigger: "blur" }],
        dataTime: [
          { required: true, message: "请先选择时间", trigger: "blur" }
        ],
        do: [
          {
            pattern: /^-?[0-9]{1,4}([.][0-9]{1,2})?$/,
            message: "溶解氧范围为：-9999.00~9999.00"
          }
        ],
        ph: [
          {
            pattern: /^(([0-9]|1[0-3])(\.[0-9]{1,2})?|14)$/,
            message: "PH范围为：0.00-14"
          }
        ],
        temp: [
          {
            pattern: /^(\d{1,2}(\.\d{1,2})?|100)$/,
            message: "水温范围：0.00~100"
          }
        ],
        electroRedox: [
          {
            pattern: /^-?[0-9]{1,4}([.][0-9]{1,2})?$/,
            message: "氧化电还原范围为：-9999.00~9999.00"
          }
        ],
        nitrite: [
          {
            pattern: /^$|^-?[0-9]{1,4}([.][0-9]{1,2})?$/,
            message: "亚盐范围为：-9999.00~9999.00"
          }
        ],
        ammoniaNitrogen: [
          {
            pattern: /^$|^-?[0-9]{1,4}([.][0-9]{1,2})?$/,
            message: "氨氮范围为：-9999.00~9999.00"
          }
        ]
      }
    };
  },
  async mounted() {
    this.baseList = await this.getAllBaseList(); //基地
    this.baseForm.fishBaseId = this.baseList[0].key;
    console.log(this.baseList, this.baseForm.fishBaseId);

    this.pondList = await this.getFishPond(this.baseForm.fishBaseId); //塘口
    this.baseForm.pondId = this.pondList[0].key;
  },
  computed: {},
  methods: {
    ...mapActions(modules.waterQualityParameter, ["addWQParameter"]),
    ...mapActions(modules.pond, [
      "getFishPond" //塘口
    ]),
    ...mapActions(modules.base, [
      "getAllBaseList" //基地信息
    ]),

    //改变基地数据
    async baseChange(e, notShowTip) {
      let selectedBase = this.baseList.find(f => f.key == e);
      if (!notShowTip && selectedBase && !selectedBase.notCleard) {
        this.$Alert.info({
          content: "当前选择的基地已经全部清塘，请选择其他基地",
          duration: 5000,
          status: "error"
        });
        // Message.error("当前选择的基地已经全部清塘，请选择其他基地");
      }
      let a = await this.getFishPond(e);
      this.pondList = a;
      if (this.pondList.length === 0) {
        this.$Alert.info({
          content: "当前选择的基地下无塘口，请先添加塘口信息",
          duration: 5000,
          status: "error"
        });
        // Message.error("当前选择的基地下无塘口，请先添加塘口信息");
      }
      this.baseForm.pondId = null;
    },
    //保存
    saveBase(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            electroRedox: this.baseForm.electroRedox,
            temp: this.baseForm.temp,
            do: this.baseForm.do,
            ph: this.baseForm.ph,
            nitrite: this.baseForm.nitrite,
            ammoniaNitrogen: this.baseForm.ammoniaNitrogen,
            dataTime: this.baseForm.dataTime,
            pondId: this.baseForm.pondId,
            fishBaseId: this.baseForm.fishBaseId
          };
          this.addWQParameter(obj)
            .then(rsp => {
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.$router.push({
                  name: "paramsInput"
                });
                this.baseForm = {
                  electroRedox: "",
                  temp: "",
                  do: "",
                  ph: "",
                  nitrite: "",
                  ammoniaNitrogen: "",
                  dataTime: "",
                  pondId: "",
                  fishBaseId: ""
                };
                this.$refs[formName].resetFields();
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
            });
        } else {
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      history.go(-1);
    }
  }
};
</script>

<style lang="" >
</style>
